<template>
  <br /><br /><br /><br /><br />
  <div class="upload">
    <div class="admincontainer">
      <div class="navigation">
        <div class="selector">
          <div class="item" @click=";(navselect = 'users'), getUsers()">
            Users
          </div>
          <div class="item" @click=";(navselect = 'companys'), getCompanys()">
            Companys
          </div>
        </div>
        <div v-if="navselect == 'users'" class="list">
          name: <input size="15" v-model="newname" type="text" /> <br />
          email:<input size="15" v-model="newemail" type="text" />{{}}<br />
          password:<input size="15" v-model="newpassword" type="text" /><br />
          <input @click="addUser()" type="button" value="adduser" />
          <div
            v-for="user in users"
            :key="user.uuid"
            @click="getUser(user.uuid)"
            class="item"
          >
            - {{ user.name }}: {{ user.email }}
          </div>
          <br />
        </div>

        <div v-if="navselect == 'companys'" class="list">
          name: <input size="15" v-model="newname" type="text" /> <br />
          <input @click="addCompany()" type="button" value="addComapany" />
          <div
            v-for="company in companys"
            :key="company.uuid"
            @click="getCompany(company.uuid)"
            class="item"
          >
            - {{ company.name }}
          </div>
          <br />
        </div>
      </div>
      <div class="itemdisplay">
        <div v-if="user && navselect == 'users'">
          <h2>
            Users/{{ user.name }}
            <input type="button" @click="deleteUser(user.uuid)" value="Del" />
          </h2>
          <h3>{{ user.email }}</h3>
          <h3>{{ user.valid }}</h3>
          <h4>
            Change password: <input type="text" /> <input type="text" />
            <input type="button" value="change" />
          </h4>

          <h4>Perms :</h4>
          <div v-if="user.perms">
            <h5
              v-for="perm in Object.keys(user.perms)"
              :key="perm"
              @click="setnewpar(perm, user.perms[perm])"
            >
              - {{ perm }}: {{ user.perms[perm] }}
            </h5>
          </div>
          Addperm: <input type="text" v-model="newpar.name" /> Value:
          <input size="10" type="text" v-model="newpar.value" />> Start:
          <input type="datetime-local" name="" id="" v-model="newpar.start" />
          End:
          <input type="datetime-local" name="" id="" v-model="newpar.expired" />
          <input
            type="button"
            value="add"
            @click="
              editUser(user.uuid, {
                type: 'editperm',
                name: newpar.name,
                value: {
                  value: newpar.value,
                  start: Date.parse(newpar.start),
                  expired: Date.parse(newpar.expired),
                },
              })
            "
          />
          <input
            type="button"
            value="Del"
            @click="
              editUser(user.uuid, {
                type: 'remperm',
                name: newpar.name,
              })
            "
          />

          <h4>companys : {{}}</h4>
          <div v-if="user.companys && user.companys[0] != null">
            <h5 v-for="company in user.companys" :key="company.uuid">
              - {{ company.name }}
            </h5>
          </div>
        </div>

        <div v-if="company && navselect == 'companys'">
          <h2>
            Company/{{ company.name }}
            <input
              type="button"
              @click="deleteCompany(company.uuid)"
              value="Del"
            />
          </h2>
          <div v-for="prop in companyProps" :key="prop">
            {{ prop.name }}:
            <input
              v-if="prop.boolean"
              type="checkbox"
              v-model="prop.value"
              @change.prevent="
                editCompany(company.uuid, {
                  type: 'prop',
                  name: prop.name,
                  value: prop.value,
                })
              "
            /><input
              v-else
              type="text"
              v-model="prop.value"
              @blur.prevent="
                editCompany(company.uuid, {
                  type: 'prop',
                  name: prop.name,
                  value: prop.value,
                })
              "
            />
          </div>
          <h4>Perms :</h4>
          <div v-if="company.perms">
            <h5
              v-for="perm in Object.keys(company.perms)"
              :key="perm"
              @click="setnewpar(perm, company.perms[perm])"
            >
              - {{ perm }}: {{ company.perms[perm] }}
            </h5>
          </div>
          Addperm: <input type="text" v-model="newpar.name" /> Value:
          <input size="10" type="checkbox" v-model="newpar.value" />>

          <input
            type="button"
            value="add"
            @click="
              editCompany(company.uuid, {
                type: 'editperm',
                name: newpar.name,
                value: newpar.value,
              })
            "
          />
          <input
            type="button"
            value="Del"
            @click="
              editCompany(company.uuid, {
                type: 'remperm',
                name: newpar.name,
              })
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, reactive, ref, defineComponent } from "vue"
import { useStore } from "vuex"
import { setup, Vue } from "vue-class-component"
import { usePerms } from "../logic/usePerms"
import axios from "axios"

export default defineComponent({
  components: {},
  setup() {
    /* eslint-disable */
    const store = useStore()
    const { hasPerm, checkToken } = usePerms()

    const navselect = ref("users")

    const token = computed(() => store.getters["auth/token"])
    const host = computed(() => store.getters["auth/host"])

    const newname = ref("")
    const newemail = ref("")
    const newpassword = ref("")

    /*     const emailvalid = (email: string)=>{
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase())}
    
      const namevalid = (name: string)=>{      
          const re = /^[a-zA-Z0-9]{5,21}$/;
          return re.test(String(name).toLowerCase()) }
          
    
      const passwordvalid = (pass: string)=>{      
          const re = /^[a-zA-Z0-9]{9,21}$/;
          return re.test(String(pass).toLowerCase()) } */

    const newpar: any = reactive({ name: "", value: "" })

    const setnewpar = async (name: string, perm: any) => {
      newpar.name = name
      if (perm == true) {
        newpar.value = "true"
      }

      const { value, start, expired } = perm
      newpar.start = null
      newpar.expired = null
      if (value) {
        newpar.value = value
      }
      if (start) {
        newpar.start = new Date(start).toISOString()
      }
      if (expired) {
        newpar.expired = expired
      }
    }

    // User functions
    const users = ref([])
    const getUsers = async () => {
      await checkToken()

      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/users",
          data: {},
          method: "GET",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            users.value = resp.data.users
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    const user = ref()
    const getUser = async (uuid: string) => {
      await checkToken()
      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/users/" + uuid,
          data: {},
          method: "GET",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            user.value = resp.data.user
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    const addUser = async () => {
      //validate formdata

      await checkToken()
      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/users",
          data: {
            name: newname.value,
            email: newemail.value,
            password: newpassword.value,
          },
          method: "post",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            users.value = resp.data.users
            user.value = resp.data.user
          })
          .catch((err) => {
            console.log(err)
          })
      }
      newname.value = ""
      newemail.value = ""
      newpassword.value = ""
    }

    const editUser = async (uuid: string, edit: any) => {
      await checkToken()
      if (hasPerm("system.admin")) {
        if (edit.value) {
          if (edit.value == "true") {
            edit.value = true
          }
          const { value, start, expired } = edit.value
          if (value) {
            if (value == "true") {
              edit.value.value = true
            }
          }
          if (value && start && expired) {
            if (value == "true" && expired == null && start == null) {
              edit.value = true
            }
          }
        }

        axios({
          baseURL: host.value,
          url: "/users/" + uuid,
          data: {
            patch: [edit],
          },
          method: "patch",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            users.value = resp.data.users
            user.value = resp.data.user
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    const deleteUser = async (uuid: string) => {
      await checkToken()
      if (hasPerm("system.admin")) {
        console.log(uuid)
        axios({
          baseURL: host.value,
          url: "/users/" + uuid,
          data: {},
          method: "delete",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            user.value = undefined
            users.value = resp.data.users
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    // Company functions
    const companys = ref([])
    const getCompanys = async () => {
      await checkToken()

      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/companys",
          data: {},
          method: "GET",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            companys.value = resp.data.companys
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    const company = ref()
    const getCompany = async (uuid: string) => {
      await checkToken()
      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/companys/" + uuid,
          data: {},
          method: "GET",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            company.value = resp.data.company
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    const addCompany = async () => {
      //validate formdata

      await checkToken()
      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/companys",
          data: {
            name: newname.value,
          },
          method: "post",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            companys.value = resp.data.companys
            company.value = resp.data.company
          })
          .catch((err) => {
            console.log(err)
          })
      }
      newname.value = ""
    }

    const companyProps = computed(() => {
      const cprops = []
      const booleans = ["active", "ehf"]
      const props = [
        "name",
        "domain",
        "active",
        "org",
        "address",
        "zip",
        "city",
        "country",
        "ehf",
        "email",
      ]

      for (let i = 0; i < props.length; i++) {
        const prop = props[i]
        let value = company.value[prop] || ""
        cprops.push({
          name: prop,
          value: value,
          boolean: booleans.includes(prop),
        })
      }
      return cprops
    })

    const editCompany = async (uuid: string, edit: any) => {
      await checkToken()
      console.log(edit.value)
      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/companys/" + uuid,
          data: {
            patch: [edit],
          },
          method: "patch",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            companys.value = resp.data.companys
            company.value = resp.data.company
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    const deleteCompany = async (uuid: string) => {
      await checkToken()
      if (hasPerm("system.admin")) {
        axios({
          baseURL: host.value,
          url: "/companys/" + uuid,
          data: {},
          method: "delete",
          headers: {
            Authorization: "Bearer " + token.value,
          },
        })
          .then((resp) => {
            company.value = undefined
            companys.value = resp.data.companys
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    getUsers()

    return {
      islogedIn: computed(() => store.getters["auth/isLogedIn"]),
      username: computed(() => store.getters["auth/username"]),
      hasPerm,
      navselect,
      newname,
      newemail,
      newpassword,
      newpar,
      setnewpar,
      users,
      user,
      getUsers,
      getUser,
      addUser,
      editUser,
      deleteUser,
      companys,
      company,
      getCompanys,
      getCompany,
      addCompany,
      editCompany,
      deleteCompany,
      companyProps,
    }
  },
})
</script>

<style lang="scss">
.admincontainer {
  width: 100vw;

  display: grid;

  grid-template-columns: 2fr 4fr;
  grid-template-areas: "navigation";

  .navigation {
    grid-area: "navigation";
    display: grid;
    grid-template-rows: 40px auto;

    .selector {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }

    .list {
      text-align: left;
      margin-left: 40px;
    }
  }
  .itemdisplay {
    text-align: left;
  }
}
</style>
